export interface AuthReduxState {
    authToken?: string | undefined
}

export const DEFAULT_AUTH_STATE: AuthReduxState = {
    authToken: undefined,
}
